import { createMuiTheme } from "./theme";
export default createMuiTheme;

export * from "./theme";
